import viewTypes from 'helpers/enums/viewTypes'
import activityNameTypes from 'helpers/enums/metrics/activityNameTypes'

const getActivityFromCurrentView = currentView => {
	const viewsToActivityName = {
		[viewTypes.TIME_TO_CLIMB_CREATION]: activityNameTypes.TIME_TO_CLIMB,
		[viewTypes.TIME_TO_CLIMB_STANDALONE_CREATION]: activityNameTypes.TIME_TO_CLIMB,
		[viewTypes.DRAW_IT_CREATION]: activityNameTypes.DRAW_IT,
		[viewTypes.DRAW_IT_STANDALONE_CREATION]: activityNameTypes.DRAW_IT,
		[viewTypes.MATCHING_PAIRS_CREATION]: activityNameTypes.MATCHING_PAIRS,
		[viewTypes.MATCHING_PAIRS_STANDALONE_CREATION]: activityNameTypes.MATCHING_PAIRS,
	}

	return viewsToActivityName[currentView] || ''
}

export default getActivityFromCurrentView
